import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Router } from '@angular/router';
import { fuseAnimations } from '../../../../../core/animations';
import * as _ from 'lodash';

//Service file
import { AuthService } from '../../authentication/auth.service';
import { EcommerceOrdersService } from './orders.service';

/**Local file */
import { spekwo, login, toolTip, decodeData, marketsReports } from '../../utils/index';
import { ConfigurationService } from '../../configuration/configuration.service';

@Component({
  selector: 'orders-new',
  templateUrl: './orders-new.component.html',
  styleUrls: ['./orders-new.component.scss'],
  animations: fuseAnimations
})
export class OrdersNewComponent implements OnInit {

  spekwoValues = spekwo;
  loginValues = login;
  toolTipValues = toolTip;

  onRoleSubscription: Subscription;
  onCurrentTodoChanged: Subscription;

  currentUserName: string;
  currentUserChangedSubscription: Subscription;

  role: string;
  currentTodo: string;

  marketList: any[] = [];
  formValues = marketsReports;
  isLoader: boolean = false;
  currentMonthStart: Date;
  currentMonthEnd: Date;
  selectedFilter: string = 'Current Month (MTD)'; // Default filter
  filterOptions: string[] = [
    'Current Month (MTD)',
    'Current Year (YTD)',
    'Last Month',
    'Last 3 Months',
    'Last 6 Months',
    'Last Year'
  ];

  constructor(
    public router: Router,
    public authService: AuthService,
    public ordersService: EcommerceOrdersService,
    public configurationService: ConfigurationService
  ) {
    this.setDateBoundaries();
  }

  ngOnInit() {
    this.onRoleSubscription =
      this.authService.onCurrentUserChanged.subscribe(user => {
        this.role = user.roleByRoleId.roleName;
      });

    this.onCurrentTodoChanged =
      this.ordersService.onCurrentTodoChanged
        .subscribe(([currentTodo]) => {
          if (!currentTodo) {
            this.currentTodo = null;
          }
          else {
            this.currentTodo = currentTodo;
          }
        });

    this.currentUserChangedSubscription =
      this.authService.onCurrentUserChanged.subscribe(user => {
        this.currentUserName = user.firstName + ' ' + user.lastName;
      });
    this.getAllMarkets();
  }

  ngOnDestroy() {
    this.onRoleSubscription.unsubscribe();
    this.onCurrentTodoChanged.unsubscribe();
    this.currentUserChangedSubscription.unsubscribe();
  }

  private setDateBoundaries(): void {
    const now = new Date();
    // Current Month boundaries
    this.currentMonthStart = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0);
    this.currentMonthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
  }

  private isDateInRange(dateString: string, range: string): boolean {
    if (!dateString) return false;
    
    const date = new Date(dateString);
    const now = new Date();
    
    switch(range) {
      case 'Current Month (MTD)':
        return date >= this.currentMonthStart && date <= this.currentMonthEnd;
      
      case 'Current Year (YTD)':
        const yearStart = new Date(now.getFullYear(), 0, 1, 0, 0, 0, 0);
        const yearEnd = new Date(now.getFullYear(), 11, 31, 23, 59, 59, 999);
        return date >= yearStart && date <= yearEnd;
      
      case 'Last Month':
        const lastMonthStart = new Date(now.getFullYear(), now.getMonth() - 1, 1, 0, 0, 0, 0);
        const lastMonthEnd = new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59, 999);
        return date >= lastMonthStart && date <= lastMonthEnd;
      
      case 'Last 3 Months':
        const threeMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 3, 1, 0, 0, 0, 0);
        return date >= threeMonthsAgo && date <= now;
      
      case 'Last 6 Months':
        const sixMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 6, 1, 0, 0, 0, 0);
        return date >= sixMonthsAgo && date <= now;
      
      case 'Last Year':
        const lastYearStart = new Date(now.getFullYear() - 1, 0, 1, 0, 0, 0, 0);
        const lastYearEnd = new Date(now.getFullYear() - 1, 11, 31, 23, 59, 59, 999);
        return date >= lastYearStart && date <= lastYearEnd;
      
      default:
        return date >= this.currentMonthStart && date <= this.currentMonthEnd;
    }
  }

  private filterOrdersByRange(orders: any[], range: string): any[] {
    if (!orders || orders.length === 0) return [];
    
    return orders.filter(order => {
      const orderDate = order.createdAt;
      return this.isDateInRange(orderDate, range);
    });
  }

  logout() {
    window.localStorage.clear();
    this.router.navigate(['**']);
  }

  deSelectCurrentTodo() {
    this.ordersService.onCurrentTodoChanged.next([null]);
  }

  getAllMarkets() {
    this.isLoader = true;
    let marketList = [];
    this.configurationService.getMarket()
      .then((response) => {
        if (response && (response['nodes'] && response['nodes'].length > 0)) {
          response['nodes'].forEach((item) => {
            marketList.push({
              marketId: item && item.marketId ? item.marketId : "",
              marketName: item && item.marketName ? decodeData(item.marketName) : ""
            });
          });
          this.getlistOrderByMarkets(marketList);
        } else {
          this.isLoader = false;
          this.marketList = [];
        }
      })
      .catch((error) => {
        console.error('Error fetching markets:', error);
        this.isLoader = false;
        this.marketList = [];
      });
  }

  getlistOrderByMarkets(marketList) {
    let orderByMarketList = [];
    let completedRequests = 0;

    if (marketList.length === 0) {
      this.isLoader = false;
      this.marketList = [];
      return;
    }

    marketList.forEach((eachMarket) => {
      this.configurationService.getListOrderByMarket(eachMarket.marketId)
        .then((response) => {
          let approvedRepairsCount = 0;
          let totalCount = 0;
          if (response && response['nodes'] && response['nodes'].length > 0) {
            const filteredOrders = this.filterOrdersByRange(response['nodes'], this.selectedFilter);
            totalCount = filteredOrders.length;
            filteredOrders.forEach((item) => {
              if (item && 
                  item.inspectionReportsSrcByOrderId && 
                  item.inspectionReportsSrcByOrderId.scheduleRequestByScheduleRequestId && 
                  item.inspectionReportsSrcByOrderId.scheduleRequestByScheduleRequestId.id) {
                approvedRepairsCount++;
              }
            });
            let repairConversionPercentage = totalCount > 0 ? 
              ((approvedRepairsCount / totalCount) * 100).toFixed(2) : "0.00";

            orderByMarketList.push({
              marketId: eachMarket.marketId,
              marketName: eachMarket.marketName,
              quotes: totalCount,
              approvedRepairs: approvedRepairsCount,
              repairConversion: repairConversionPercentage + "%",
              filterType: this.selectedFilter
            });
          } else {
            orderByMarketList.push({
              marketId: eachMarket.marketId,
              marketName: eachMarket.marketName,
              quotes: 0,
              approvedRepairs: 0,
              repairConversion: "0%",
              filterType: this.selectedFilter
            });
          }

          completedRequests++;

          if (completedRequests === marketList.length) {
            this.isLoader = false;
            this.marketList = _.orderBy(orderByMarketList, ['marketId'], ['asc']);
          }
        })
        .catch((error) => {
          console.error(`Error fetching orders for market ${eachMarket.marketId}:`, error);
          
          orderByMarketList.push({
            marketId: eachMarket.marketId,
            marketName: eachMarket.marketName,
            quotes: 0,
            approvedRepairs: 0,
            repairConversion: "0%",
            filterType: this.selectedFilter
          });

          completedRequests++;

          if (completedRequests === marketList.length) {
            this.isLoader = false;
            this.marketList = _.orderBy(orderByMarketList, ['marketId'], ['asc']);
          }
        });
    });
  }

  onFilterChange(): void {
    this.getAllMarkets();
  }

  getFilterDisplayText(): string {
    switch(this.selectedFilter) {
      case 'Current Month (MTD)':
        return `Current Month (${this.getCurrentMonthInfo()})`;
      case 'Current Year (YTD)':
        return `Current Year (${new Date().getFullYear()})`;
      case 'Last Month':
        return `Last Month (${this.getLastMonthInfo()})`;
      case 'Last 3 Months':
        return 'Last 3 Months';
      case 'Last 6 Months':
        return 'Last 6 Months';
      case 'Last Year':
        return `Last Year (${new Date().getFullYear() - 1})`;
      default:
        return this.selectedFilter;
    }
  }

  getCurrentMonthInfo(): string {
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const currentDate = new Date();
    return `${monthNames[currentDate.getMonth()]} ${currentDate.getFullYear()}`;
  }

  getLastMonthInfo(): string {
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const currentDate = new Date();
    const lastMonth = currentDate.getMonth() === 0 ? 11 : currentDate.getMonth() - 1;
    const year = currentDate.getMonth() === 0 ? currentDate.getFullYear() - 1 : currentDate.getFullYear();
    return `${monthNames[lastMonth]} ${year}`;
  }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/orders-new.component.ts